export const environment = {
  expressUrl: 'https://dev-api.kalpapdmsdev.com',
  // tinyMceKey: 'c1j204m3d6brn3mq5ac394kuv0gptw5fv0wawyscbjwynhya',
  production: false,
  hmr: false,
  amplify: {
    Auth: {
      region: 'us-west-2',
      userPoolId: 'us-west-2_5g6RZrS99',
      userPoolWebClientId: '3ls1bavall6cplgcivqkn3s09d',
      identityPoolId: 'us-west-2:befc54d6-9792-486a-a7d2-f66eca8ff658',
    },
  },
  googleClientId: '903559517820-bb1bnbkp6mnc8ldkqq2ntu4gni9hm0dk.apps.googleusercontent.com',
  sso: {
    response_type: 'code',
    scope: 'aws.cognito.signin.user.admin email openid phone profile',
    cognitoDomain: 'https://wvv8l6x950mz-dev.auth.us-west-2.amazoncognito.com',
    redirectUri: 'https://dev.kalpapdmsdev.com/sso-callback',
    clientId: '1nh9gbls59hu2al1hhls34elug',
  },
};
